import dayjs, { Dayjs } from "dayjs";

import { IOption } from "models/Form";

const PRESET_START: Record<string, (now: Dayjs) => Dayjs> = {
  "past-30-days": (now) => now.subtract(30, "day"),
  "past-60-days": (now) => now.subtract(60, "day"),
  "past-90-days": (now) => now.subtract(90, "day"),
  ytd: (now) => now.startOf("year"),
  "past-6-months": (now) => now.subtract(6, "month"),
  "past-1-year": (now) => now.subtract(1, "year")
};

export function resolveReportDateRange(
  filterBy?: IOption,
  createdGte?: string,
  createdLte?: string
) {
  const now = dayjs();
  const presetStart = PRESET_START[filterBy?.value ?? ""] ?? PRESET_START["past-30-days"];

  return {
    start: createdGte ? dayjs(createdGte).toISOString() : presetStart(now).toISOString(),
    end: createdLte ? dayjs(createdLte).toISOString() : now.toISOString()
  };
}
